// ── Site builder section — static feature list + preview image

const SITEBUILDER_PREVIEW_SRC = '/sitebuilder-preview.png'

const IconPalette = () => (
  <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
    <circle cx="10" cy="10" r="7.5" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="7" cy="9" r="1.5" fill="currentColor"/>
    <circle cx="13" cy="9" r="1.5" fill="currentColor"/>
    <circle cx="10" cy="13.5" r="1.5" fill="currentColor"/>
  </svg>
)

const IconPhoto = () => (
  <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
    <rect x="2.5" y="4" width="15" height="12" rx="2" stroke="currentColor" strokeWidth="1.5"/>
    <circle cx="7" cy="8.5" r="1.5" fill="currentColor" opacity="0.5"/>
    <path d="M2.5 13.5l4-4 3 3 2-2 5.5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
)

const IconLayout = () => (
  <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
    <rect x="2.5" y="2.5" width="6.5" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
    <rect x="11" y="2.5" width="6.5" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
    <rect x="2.5" y="11.5" width="6.5" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
    <rect x="11" y="11.5" width="6.5" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
  </svg>
)

const IconClock = () => (
  <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
    <circle cx="10" cy="10" r="7.5" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M10 6v4l2.5 2.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

const IconUpload = () => (
  <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
    <path d="M10 13V5M10 5l-3.5 3.5M10 5l3.5 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 15.5h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
)

const features = [
  { Icon: IconPalette, title: 'Cores, fontes e identidade', desc: 'Edite cores, tipografia e estilo visual para combinar com a identidade do seu restaurante.' },
  { Icon: IconPhoto, title: 'Fotos e banner de destaque', desc: 'Faça upload de fotos do restaurante, pratos em destaque e galeria de imagens.' },
  { Icon: IconLayout, title: 'Cardápio com visual personalizado', desc: 'Estilo dos cards, pills de categoria, modal do carrinho — tudo configurável.' },
  { Icon: IconClock, title: 'Horários, contato e redes sociais', desc: 'Rodapé com horário de funcionamento, endereço, telefone e links do Instagram, iFood e mais.' },
  { Icon: IconUpload, title: 'Publicação com um clique', desc: 'Seu site vai ao ar em seurestaurante.wtr.app.br instantaneamente.' },
]

export default function SiteBuilder() {
  return (
    <section
      className="text-white px-5 py-16 sm:px-8 sm:py-20 lg:px-16 lg:py-24 scroll-mt-24"
      style={{ background: '#0E0E0C' }}
      id="como-funciona"
    >
      <div className="max-w-[1280px] mx-auto">
        <div className="text-[11px] font-bold uppercase tracking-[2px] text-white/30 mb-3">
          Seu site, do seu jeito
        </div>
        <h2 className="text-[30px] sm:text-[38px] lg:text-[50px] font-black tracking-tight leading-[1.08] text-white mb-4">
          Crie o site do<br />seu restaurante
        </h2>
        <p className="text-[15px] lg:text-[16px] text-white/50 leading-[1.75] max-w-[480px]">
          Sem programação, sem agência. Você monta cada detalhe — e publica com um clique.
        </p>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-10 xl:gap-14 mt-10 lg:mt-14 lg:items-start">

          <div className="flex-1 min-w-0 max-w-[520px] lg:max-w-[40%] xl:max-w-[420px] lg:flex-shrink-0">
            <p className="text-[13px] text-white/35 mb-6 leading-relaxed">
              Editor visual com prévia ao vivo: personalize seções (hero, endereço, carrosséis), cores e links — como no painel <span className="text-white/50">Meu Site</span>.
            </p>
            <ul className="flex flex-col gap-5">
              {features.map(({ Icon, title, desc }) => (
                <li key={title} className="flex gap-4 items-start">
                  <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center text-white/85">
                    <Icon />
                  </div>
                  <div>
                    <div className="text-[14px] font-bold text-white mb-1">{title}</div>
                    <p className="text-[12.5px] leading-[1.55] text-white/45">{desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex-1 min-w-0 w-full flex justify-center lg:justify-end">
            <div className="w-full max-w-[640px] sm:max-w-[760px] mx-auto lg:mx-0 lg:max-w-none rounded-2xl overflow-hidden border border-white/[0.1] bg-white/[0.04] shadow-[0_28px_100px_rgba(0,0,0,0.45)] ring-1 ring-white/[0.06]">
              <img
                src={SITEBUILDER_PREVIEW_SRC}
                alt="Editor de site Waithere no notebook com prévia mobile — Meu Site, seções, cores e publicação"
                className="w-full h-auto block select-none"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
